import React, { FC, useRef } from 'react';
import { ListingCard } from '../cards/listing-card/listing-card';
import { ServiceCard } from '../cards/service-card/service-card';
import { Catalog } from '../../apis/search-catalog';
import striptags from 'striptags';
import styles from './styles.module.css';
import { ChevronLeft, ChevronRight } from '@mui/icons-material';

type CardVariant = 'default' | 'service';

interface ServiceCarouselProps {
  items: Catalog[];
  onClickCatalog: (slug: string, categorySlug: string) => void;
  card?: CardVariant;
}

const STEP = 400;

export const ServiceCarousel: FC<ServiceCarouselProps> = ({
  items,
  onClickCatalog,
  card = 'default',
}) => {
  const trackRef = useRef<HTMLDivElement>(null);

  const atStart = () => {
    const t = trackRef.current;
    return !!t && t.scrollLeft <= 0;
  };

  const atEnd = () => {
    const t = trackRef.current;
    return !!t && t.scrollLeft + t.clientWidth >= t.scrollWidth - 1;
  };

  const scrollLeft = () => {
    const t = trackRef.current;
    if (!t) return;

    if (atStart()) {
      t.scrollTo({ left: t.scrollWidth, behavior: 'smooth' });
    } else {
      t.scrollBy({ left: -STEP, behavior: 'smooth' });
    }
  };

  const scrollRight = () => {
    const t = trackRef.current;
    if (!t) return;

    if (atEnd()) {
      t.scrollTo({ left: 0, behavior: 'smooth' });
    } else {
      t.scrollBy({ left: STEP, behavior: 'smooth' });
    }
  };

  const renderCard = (catalog: Catalog) => {
    if (card === 'service') {
      return (
        <ServiceCard
          key={catalog.slug}
          catalog={catalog}
          onClick={() => onClickCatalog(catalog.slug, catalog.categorySlug)}
          onSolicitar={() => onClickCatalog(catalog.slug, catalog.categorySlug)}
        />
      );
    }

    return (
      <ListingCard
        key={catalog.slug}
        title={catalog.title}
        subtitle={striptags(catalog.description)}
        type={catalog.isOnline ? 'online' : 'in-person'}
        onClick={() => onClickCatalog(catalog.slug, catalog.categorySlug)}
        onClickFavourite={() => { } }
        onClickOnlineService={() => { } }
        disposition="card"
        isDigital={catalog.isDigital}
        department={catalog.department} href={''}      />
    );
  };

  return (
    <div className={styles.carouselWrapper}>
      <div className={styles.carouselGradientLeft}>
        <button
          className={styles.carouselButtonLeft}
          aria-label="Anterior"
          onClick={scrollLeft}
        >
          <ChevronLeft />
        </button>
      </div>

      <div className={styles.carouselTrack} ref={trackRef}>
        {items?.map(renderCard)}
      </div>

      <div className={styles.carouselGradientRight}>
        <button
          className={styles.carouselButtonRight}
          aria-label="Próximo"
          onClick={scrollRight}
        >
          <ChevronRight />
        </button>
      </div>
    </div>
  );
};